import * as actions from './actions';

export default {
  messages: actions.getMessages,
  message: actions.getMessage,
};